<template>
  <div class="container-fluid">
    <loading :active.sync="isLoading" :is-full-page="false"></loading>

    <div class="row">
      <div class="col-12">
        <div class="page-title-box d-flex align-items-center justify-content-between">
          <h4 class="mb-0 font-size-18">{{ module }}</h4>
          <div class="page-title-right">
            <ol class="breadcrumb m-0">
              <li class="breadcrumb-item">
                <router-link :to="{ name: 'dashboards' }">Dashboards</router-link>
              </li>
              <li class="breadcrumb-item active">{{ module }}</li>
            </ol>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">

            <div class="d-flex justify-content-between align-items-center mb-3">
              <div class="d-flex align-items-center" style="gap:8px">
                <input
                  type="text"
                  class="form-control form-control-sm"
                  style="width:200px"
                  v-model="search.so_no"
                  placeholder="Cari No. Opname..."
                  @keyup.enter="fetchData"
                />
                <button class="btn btn-sm btn-primary" @click="fetchData">
                  <i class="mdi mdi-magnify"></i>
                </button>
              </div>
              <router-link :to="{ name: 'stock_opname_create' }" class="btn btn-sm btn-success">
                <i class="mdi mdi-plus mr-1"></i>Buat Opname
              </router-link>
            </div>

            <div class="table-responsive">
              <table class="table table-bordered table-hover table-sm">
                <thead class="thead-light">
                  <tr>
                    <th>No. Opname</th>
                    <th>Tanggal</th>
                    <th>Catatan</th>
                    <th class="text-center">Status</th>
                    <th class="text-center">Aksi</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-if="rows.length === 0">
                    <td colspan="5" class="text-center text-muted py-3">Belum ada data</td>
                  </tr>
                  <tr v-for="(row, i) in rows" :key="i">
                    <td>
                      <router-link :to="{ name: 'stock_opname_detail', params: { uuid: row.so_uuid } }">
                        {{ row.so_no }}
                      </router-link>
                    </td>
                    <td>{{ row.so_date }}</td>
                    <td>{{ row.so_notes || '-' }}</td>
                    <td class="text-center">
                      <span :class="row.so_status == 1 ? 'badge badge-success' : 'badge badge-warning'">
                        {{ row.so_status == 1 ? 'Confirmed' : 'Draft' }}
                      </span>
                    </td>
                    <td class="text-center">
                      <router-link
                        v-if="row.so_status == 0"
                        :to="{ name: 'stock_opname_edit', params: { uuid: row.so_uuid } }"
                        class="btn btn-xs btn-info mr-1"
                      ><i class="mdi mdi-pencil"></i></router-link>
                      <router-link
                        :to="{ name: 'stock_opname_detail', params: { uuid: row.so_uuid } }"
                        class="btn btn-xs btn-secondary mr-1"
                      ><i class="mdi mdi-eye"></i></router-link>
                      <button
                        v-if="row.so_status == 0"
                        class="btn btn-xs btn-danger"
                        @click="deleteRow(row.so_uuid)"
                      ><i class="mdi mdi-trash-can-outline"></i></button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            <div class="d-flex justify-content-between align-items-center mt-3">
              <small class="text-muted">Total: {{ total }} data</small>
              <paginate
                v-if="totalPage > 1"
                v-model="page"
                :pageCount="totalPage"
                :click-handler="onPageChange"
                prevText="&laquo;"
                nextText="&raquo;"
                container-class="pagination pagination-sm mb-0"
                pageClass="page-item"
                page-link-class="page-link"
                prev-class="page-item"
                prev-link-class="page-link"
                next-class="page-item"
                next-link-class="page-link"
              ></paginate>
            </div>

          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isLoading: false,
      module: "Stock Opname",
      table_module: "stock_opname",
      rows: [],
      total: 0,
      totalPage: 0,
      page: 1,
      show: 15,
      search: { so_no: "" },
    };
  },
  mounted() {
    this.fetchData();
  },
  methods: {
    fetchData() {
      this.isLoading = true;
      this.axios
        .get("/" + this.table_module, {
          params: { page: this.page, show: this.show, search: this.search },
        })
        .then((res) => {
          const d = res.data.data[this.table_module];
          this.rows      = d.data || [];
          this.total     = d.total || 0;
          this.totalPage = d.total_page || 0;
          this.isLoading = false;
        })
        .catch(() => { this.isLoading = false; });
    },
    onPageChange(p) {
      this.page = p;
      this.fetchData();
    },
    deleteRow(uuid) {
      if (!confirm("Yakin ingin menghapus data opname ini?")) return;
      this.isLoading = true;
      this.axios.post("/" + this.table_module + "/delete/" + uuid)
        .then((res) => {
          this.isLoading = false;
          this.$toast.success(res.data.message || "Berhasil dihapus");
          this.fetchData();
        })
        .catch(() => {
          this.isLoading = false;
          this.$toast.error("Gagal menghapus");
        });
    },
  },
};
</script>
